export default __webpack_public_path__ + "static/media/thumbnail.aea41f04.png";